import React, {
  useCallback,
  useMemo,
} from 'react'

import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import URL from 'utils/url'

import { useWebsite } from 'components/WebsiteProvider'

import makeTextLinkRenderer from '../lib/makeTextLinkRenderer'

import Locale from './locale'


export default function AgreeToUseParagraph({ handleShowDocument, handleShowPreferences }) {
  const { policiesByType } = useWebsite()

  const handleCookiePolicyClick = useCallback(() => {
    const {
      name,
      uuid,
    } = policiesByType.Cookie

    handleShowDocument(URL.docLink(name, uuid))
  }, [handleShowDocument, policiesByType])

  const byClickingValues = useMemo(() => ({
    cookiePolicyLink: makeTextLinkRenderer({
      dataTid: 'cookie-policy-link',
      handleClick: handleCookiePolicyClick,
    }),

    preferencesLink: makeTextLinkRenderer({
      dataTid: 'preferences-link',
      handleClick: handleShowPreferences,
    }),
  }), [handleCookiePolicyClick, handleShowPreferences])

  return (
    <FormattedMessage
      { ...Locale.byClicking }
      values={ byClickingValues }
    />
  )
}

AgreeToUseParagraph.propTypes = {
  handleShowDocument: PropTypes.func.isRequired,
  handleShowPreferences: PropTypes.func.isRequired,
}
